const token = [
	{
		path: '/token/dashboard',
		name: 'token-dashboard',
		component: () => import('@/views/token/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,website',
		},
	},
	{
		path: '/token/settings',
		name: 'token-settings',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,website',
		},
	},
	{
		path: '/token/messages',
		name: 'token-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,website',
		},
	},
	{
		path: '/token/newsletter',
		name: 'token-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,website',
		},
	},
	{
		path: '/token/notifications',
		name: 'token-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,website',
		},
	},
	{
		path: '/token/sale/rounds',
		name: 'token-sale-list',
		component: () => import(/* webpackChunkName: "TokenSaleList" */ '@/views/token/sale/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,token-sale',
		},
	},
	{
		path: '/token/sale/rounds/create',
		name: 'token-sale-create',
		component: () => import(/* webpackChunkName: "TokenSaleForm" */ '@/views/token/sale/form.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,token-sale',
		},
	},
	{
		path: '/token/sale/rounds/edit/:id',
		name: 'token-sale-edit',
		component: () => import(/* webpackChunkName: "TokenSaleForm" */ '@/views/token/sale/form.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,token-sale',
		},
	},
	{
		path: '/token/sale/rounds/:id/entries',
		name: 'token-sale-entries',
		component: () => import(/* webpackChunkName: "TokenSaleEntries" */ '@/views/token/sale/entries.vue'),
		meta: {
			layout: 'content',
			module: 'MGT,token-sale',
		},
	},
]

export default token
